/**
 * 移除用户信息对象中的 token 字段，防止 token 泄露到 localStorage
 * @param {Object} data - 用户信息对象
 * @returns {Object} 移除 token 后的用户信息对象
 */
export function sanitizeUserInfo(data) {
  if (!data || typeof data !== 'object') return data
  const { token, ...rest } = data
  console.log("行号: 9", token)
  return rest
}
